export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-background-100 to-background-50 rounded-3xl border border-background-200 p-8 md:p-12">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
            <div className="flex-shrink-0">
              <div className="w-28 h-28 md:w-36 md:h-36 rounded-3xl bg-primary-500 flex items-center justify-center shadow-2xl">
                <i className="ri-smartphone-line text-white text-5xl"></i>
              </div>
            </div>
            <div className="flex-1 text-center md:text-left">
              <span className="inline-flex items-center gap-1.5 bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
                <i className="ri-download-line text-sm"></i>
                移动端
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
                手机吃瓜更便捷
              </h2>
              <p className="text-foreground-600 text-sm leading-relaxed mb-6 max-w-md">
                91黑料吃瓜移动端适配已全面升级，支持iOS和Android双平台浏览。
                随时随地打开手机就能掌握最新娱乐圈动态，吃瓜体验无缝衔接，推送通知让你不再错过任何猛料。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
                <div className="inline-flex items-center gap-2 bg-foreground-950 text-white px-6 py-3 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap transition-all hover:bg-foreground-800">
                  <i className="ri-apple-fill text-lg"></i>
                  App Store 下载
                </div>
                <div className="inline-flex items-center gap-2 bg-foreground-950 text-white px-6 py-3 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap transition-all hover:bg-foreground-800">
                  <i className="ri-android-fill text-lg"></i>
                  Android 下载
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}